var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAhrFilledIconFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.5938C0.215625 22.4891 1.02188 23.15 1.98281 23.15H28.0125C28.9734 23.15 29.7797 22.4891 29.9953 21.5938H0Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2094 8.86328H14.7969C8.21094 8.86328 2.81563 14.0992 2.5625 20.6195H27.4438C27.1859 14.0992 21.7953 8.86328 15.2094 8.86328Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8234 7.81875H14.3062V8.4C14.4656 8.39531 14.6297 8.39062 14.7937 8.39062H15.2812V7.81875H15.7687C16.0359 7.81875 16.2562 7.60312 16.2562 7.33125C16.2562 7.06406 16.0406 6.84375 15.7687 6.84375H13.8234C13.5562 6.84375 13.3359 7.05937 13.3359 7.33125C13.3406 7.60312 13.5562 7.81875 13.8234 7.81875Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhrFilledIconFour);
export default __webpack_public_path__ + "static/media/ahr-filled-icon-four.40a7f0a99c9c4a4e4685e129b66cd8ed.svg";
export { ForwardRef as ReactComponent };